import { ApolloLink } from '@apollo/client';
import { map } from 'rxjs/operators';

const omitTypename = (key: string, value: any) => (key === '__typename' ? undefined : value);

export const removeTypeName = new ApolloLink((operation, forward) => {
  if (operation.variables) {
    operation.variables = JSON.parse(JSON.stringify(operation.variables), omitTypename);
  }

  return forward(operation).pipe(
    map((data: ApolloLink.Result) => {
      //Just in case need to transformt the data
      return data;
    })
  );
});
